import SubcategoryPage from '@/components/template/SubcategoryPage';

const KoiStool = () => {
  const products = [
    {
      title: "Koi Stool Light",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80",
      url: "/proizvodi/koi-stool-light"
    },
    {
      title: "Koi Stool Dark",
      imageSrc: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80",
      url: "/proizvodi/koi-stool-dark"
    },
    {
      title: "Koi Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&q=80",
      url: "/proizvodi/koi-stool-premium"
    },
    {
      title: "Koi Stool Deluxe",
      imageSrc: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/koi-stool-deluxe"
    },
    {
      title: "Koi Stool Elegant",
      imageSrc: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/koi-stool-elegant"
    },
    {
      title: "Koi Stool Natural",
      imageSrc: "https://images.unsplash.com/photo-1503602642458-232111445657?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/koi-stool-natural"
    }
  ];

  return (
    <SubcategoryPage
      title="Koi Stool"
      description="Elegantni Koi stolčki, navdihnjeni z vzhodnjaško estetiko, za dodajanje harmonije vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default KoiStool;